import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/contao': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M45.4 305C59.8 372.1 71.8 434 113.6 480H34C15.3 480 0 464.8 0 446V66C0 47.3 15.2 32 34 32H91.7C77.9 44.6 65.6 59.2 54.8 75.6 9.4 145.6 27.8 222.4 45.4 305zM478 32H387.8C409.2 53.4 427 81.5 440.5 116.1L303.4 145.4C288.5 116.4 265.6 92.1 220.8 101.5 196.2 106.8 179.8 120.8 172.5 136.1 163.7 154.8 159.3 175.9 180.7 276.4 201.8 376.6 214.4 394.1 230.2 407.6 243.1 418.7 263.6 424.6 288.5 419.3 333 409.9 344.2 378.6 345.9 346.1L483.3 316.5C486.5 388 464.6 441.7 425.9 480.1H478C496.7 480.1 512 464.9 512 446.1V66C512 47.2 496.8 32 478 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/contao.js
// module id = t1Wd
// module chunks = 144